<template>
    <div class="top-bar-margin">
        <v-app-bar
                color="#00ADB5"
                class="top-app-bar"
                fixed
        >
            <v-app-bar-nav-icon class="nav-bar-icon-color" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

            <v-toolbar-title class="d-flex align-center">
                <v-icon color="#EEEEEE" class="ml-2">mdi-electron-framework</v-icon>
                تامین صنعت
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-menu
                    right
                    bottom
                    offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" fab icon>
                        <v-icon color="#EEEEEE">mdi-account</v-icon>
                    </v-btn>
                </template>

                <v-list width="150px" color="#393E46">
                    <v-list-item @click="$store.dispatch('signOut')">
                        <v-list-item-title>
                            <span class="centered-text-in-list">خروج</span>
                            <v-icon color="#EEEEEE" class="left-floated">mdi-door</v-icon>
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="$router.push('/profile')">
                        <v-list-item-title>
                            <span class="centered-text-in-list">پروفایل</span>
                            <v-icon color="#EEEEEE" class="left-floated">mdi-pen</v-icon>
                        </v-list-item-title>
                    </v-list-item>

                </v-list>
            </v-menu>
        </v-app-bar>

        <v-navigation-drawer
                v-model="drawer"
                fixed
                bottom
                temporary
                right
                width="280"
                color="#393E46"
        >
            <v-list
                    nav
                    dense
            >
                <v-list-item-group>
                    <v-row>
                        <v-col cols="12" class="drawer-header" @click="$router.push('/')">
                            <v-icon size="64" color="#00ADB5">mdi-electron-framework</v-icon>
                            <div class="drawer-header__title">پنل مدیریت تامین صنعت</div>
                        </v-col>
                    </v-row>

                    <v-list-item to="/profile" color="#00ADB5">
                        <v-list-item-title>
                            <span class="centered-text-in-list">پروفایل</span>
                            <v-icon color="#EEEEEE" class="left-floated">mdi-account</v-icon>
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item to="/admins" color="#00ADB5">
                        <v-list-item-title>
                            <span class="centered-text-in-list">مدیران</span>
                            <v-icon color="#EEEEEE" class="left-floated">mdi-account-group</v-icon>
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item to="/customers" color="#00ADB5">
                        <v-list-item-title>
                            <span class="centered-text-in-list">کاربران</span>
                            <v-icon color="#EEEEEE" class="left-floated">mdi-account-group-outline</v-icon>
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item to="/messages" color="#00ADB5">
                        <v-list-item-title>
                            <span class="centered-text-in-list" style="margin-top: 0">
                                پیام های کاربران <span v-if="$store.state.unreadMessages" class="unread-messages-counter">{{ $store.state.unreadMessages }}</span>
                            </span>
                            <v-icon color="#EEEEEE" class="left-floated">mdi-mail</v-icon>
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item to="/categories" color="#00ADB5">
                        <v-list-item-title>
                            <span class="centered-text-in-list">دسته بندی ها</span>
                            <v-icon color="#EEEEEE" class="left-floated">mdi-shape</v-icon>
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item to="/specifications" color="#00ADB5">
                        <v-list-item-title>
                            <span class="centered-text-in-list">ویژگی های محصولات</span>
                            <v-icon color="#EEEEEE" class="left-floated">mdi-file-document-plus</v-icon>
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item to="/orders" color="#00ADB5">
                        <v-list-item-title>
                            <span class="centered-text-in-list">سفارشات</span>
                            <v-icon color="#EEEEEE" class="left-floated">mdi-shopping</v-icon>
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item to="/products" color="#00ADB5">
                        <v-list-item-title>
                            <span class="centered-text-in-list">محصولات</span>
                            <v-icon color="#EEEEEE" class="left-floated">mdi-toolbox</v-icon>
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item to="/posts" color="#00ADB5">
                        <v-list-item-title>
                            <span class="centered-text-in-list">بلاگ</span>
                            <v-icon color="#EEEEEE" class="left-floated">mdi-note-plus</v-icon>
                        </v-list-item-title>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item color="#00ADB5" disabled class="mt-3">
                        <v-list-item-title>
                            <span class="centered-text-in-list">تنظیمات</span>
                            <v-icon color="#EEEEEE" class="left-floated">mdi-cog</v-icon>
                        </v-list-item-title>
                    </v-list-item>

                    <v-list
                        nav
                        dense
                    >
                        <v-list-item-group>
                            <v-list-item to="/settings/seo">
                                <v-list-item-title>
                                    <span class="centered-text-in-list">سئو</span>
                                    <v-icon color="#EEEEEE" class="left-floated">mdi-web</v-icon>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item to="/settings/home_page">
                                <v-list-item-title>
                                    <span class="centered-text-in-list">صفحه اصلی</span>
                                    <v-icon color="#EEEEEE" class="left-floated">mdi-home</v-icon>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item to="/settings/contact_us">
                                <v-list-item-title>
                                    <span class="centered-text-in-list">صفحه تماس با ما</span>
                                    <v-icon color="#EEEEEE" class="left-floated">mdi-mail</v-icon>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item to="/settings/about_us">
                                <v-list-item-title>
                                    <span class="centered-text-in-list">صفحه درباره ما</span>
                                    <v-icon color="#EEEEEE" class="left-floated">mdi-information</v-icon>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item to="/settings/footer">
                                <v-list-item-title>
                                    <span class="centered-text-in-list">صفحه فوتر</span>
                                    <v-icon color="#EEEEEE" class="left-floated">mdi-page-layout-footer</v-icon>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>

                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>

    </div>
</template>

<script>
export default {
    name: "TopBar",

    data() {
        return {
            drawer: false,
        }
    }
}
</script>

<style scoped>
.left-floated {
    float: left;
}

.centered-text-in-list {
    position: absolute;
    margin-top: 3px;
}

.nav-bar-icon-color {
    color: #EEEEEE !important;
}

.top-bar-margin {
    margin-bottom: 80px;
}

.top-app-bar {
    background-image: linear-gradient(90deg, #00ADB5 0%, #00838a 100%) !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25) !important;
}

.drawer-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 24px 0 16px;
    margin-bottom: 8px;
    cursor: pointer;
    border-bottom: 1px solid rgba(238, 238, 238, 0.08);
}

.drawer-header__title {
    font-size: 14px;
    opacity: 0.8;
}

.unread-messages-counter {
    background: orange;
    width: 25px;
    padding: 5px;
    border-radius: 50%;
    display: inline-flex;
    height: 25px;
    justify-content: center;
    margin-right: 10px;
}
</style>